// generated by recipeyak.api.base.codegen
import { http } from "@/apiClient"

export function calendarPinCreate(params: { calendar_id: number }) {
  return http<unknown>({
    url: "/api/v1/calendars/{calendar_id}/pin/",
    method: "post",
    params,
    pathParamNames: ["calendar_id"],
  })
}
